import { Routes } from '~/api/api-routes'
import axios from '~/api/axiosBase'

export const fetchUserConfig = async (keys = '') => {
  return (await axios.get(`${Routes.common.config}?keys=${keys}`)).data.data
}

export const updateUserConfig = async (data = {}) => {
  const response = await axios.post(Routes.common.config, [
    {
      key: data.key,
      context: {
        value: data.value,
      },
    },
  ])

  return response?.data?.data
}
